import { CssDevice } from '@gig/magic-common';
import { BREAKPOINT_DEVICE_QUERY, BREAKPOINT_LANDSCAPE_QUERY, BREAKPOINT_FULLSCREEN_UPDATED, BREAKPOINT_DEVICE_UPDATED, BREAKPOINT_LANDSCAPE_UPDATED } from '@gig/magic-messages';

class CssBreakpointsV2Service {
  constructor(breakpoints, deviceService) {
    this.deviceService = deviceService;
    this.devices = [
      CssDevice.MOBILE,
      CssDevice.PHABLET,
      CssDevice.TABLET,
      CssDevice.DESKTOP,
      CssDevice.LARGE
    ];
    this.mediaQueryListeners = [];
    this.landscapeMediaQueryListener = null;
    this.registerBreakpointQuery();
    this.registerBreakpointEvents();
    this.setup(breakpoints);
  }
  registerBreakpointQuery() {
    window.queryBus.subscribe(BREAKPOINT_DEVICE_QUERY, () => {
      return this.device;
    });
    window.queryBus.subscribe(BREAKPOINT_LANDSCAPE_QUERY, () => {
      return this.landscape;
    });
  }
  registerBreakpointEvents() {
    window.eventBus.register(BREAKPOINT_FULLSCREEN_UPDATED, {
      type: "boolean"
    });
  }
  setup(breakpoints) {
    if (typeof window.matchMedia !== "undefined") {
      this.mediaQueryListeners = this.devices.map((device) => {
        const mqListener = matchMedia(`(min-width: ${breakpoints[device].width}px)`);
        mqListener.addEventListener("change", () => {
          this.device = this.lastMatch;
          this.deviceService.updateDevice(this.device);
          window.eventBus.publish(BREAKPOINT_DEVICE_UPDATED, this.device);
        });
        return mqListener;
      });
      const landscapeListener = matchMedia("(orientation: landscape)");
      landscapeListener.addEventListener("change", (e) => {
        this.landscape = e.matches;
        window.eventBus.publish(BREAKPOINT_LANDSCAPE_UPDATED, this.landscape);
      });
      this.landscapeMediaQueryListener = landscapeListener;
    }
    this.device = this.lastMatch;
    this.deviceService.updateDevice(this.device);
    window.eventBus.publish(BREAKPOINT_DEVICE_UPDATED, this.device);
    this.landscape = this.isLandscape;
    window.eventBus.publish(BREAKPOINT_LANDSCAPE_UPDATED, this.landscape);
  }
  isDesktop() {
    return [CssDevice.DESKTOP, CssDevice.LARGE].indexOf(this.device) !== -1;
  }
  get lastMatch() {
    return this.devices[this.mediaQueryListeners.map((mql) => mql.matches).lastIndexOf(true)] || CssDevice.MOBILE;
  }
  get isLandscape() {
    if (this.landscapeMediaQueryListener) {
      return this.landscapeMediaQueryListener.matches;
    }
    return false;
  }
}

export { CssBreakpointsV2Service };
